import { registerApplication, start } from "single-spa";
import PubSub from "pubsub-js";
import { createLoader } from "./components/Loader";
import { createAppContainer } from "./helpers/dom-helper";

let removeLoader: () => void;

const publish = (event: string, data: any) => PubSub.publish(event, data);
const subscribe = (event: string, callback: any) =>
  PubSub.subscribe(event, callback);
const unSubscribe = (event: string) => PubSub.unsubscribe(event);

subscribe("test", (data: any, d: any) => console.log(data, " => ", d));
publish("test", { url: "http://localhost:8080/" });
unSubscribe("test");
publish("test", { url: "http://localhost:8080/" });

let isGatewayReady = false;

subscribe("GATEWAY_READY", (event: string, data: any) => {
  console.log("GATEWAY_READY", data);
  // console.log("removeLoader => ", removeLoader);
  isGatewayReady = true;

  const interval = setInterval(() => {
    if (removeLoader) {
      clearInterval(interval);
      removeLoader();
    }
  }, 1000);
});

interface MicrofrontendApp {
  bootstrap: () => Promise<void>;
  mount: () => Promise<void>;
  unmount: () => Promise<void>;
}

const waitForGatewayToBeReady = async () => {
  return new Promise((resolve) => {
    const t = setInterval(() => {
      if (isGatewayReady) {
        clearInterval(t);
        resolve(true);
      }
    }, 500);
  });
};

async function loadApp({ name }: { name: string }) {
  createAppContainer(name);

  try {
    const appModule = await System.import(name);
    const { bootstrap, mount, unmount } = appModule;

    if (name !== "@ineni-org/Gateway") {
      removeLoader = createLoader();
      // console.log("loading created => ", removeLoader);
      await waitForGatewayToBeReady();
    }

    console.log("================================");
    console.log(`Loading ${name}`);
    console.log("================================");

    if (
      Array.isArray(bootstrap) &&
      Array.isArray(mount) &&
      Array.isArray(unmount)
    ) {
      return appModule as MicrofrontendApp;
    }

    if (
      appModule &&
      typeof bootstrap === "function" &&
      typeof mount === "function" &&
      typeof unmount === "function"
    ) {
      return appModule as MicrofrontendApp;
    }

    throw new Error(`Module ${name} does not have required lifecycle methods.`);
  } catch (error) {
    console.error(`Failed to load application "${name}":`, error);
    return {
      bootstrap: () => Promise.resolve(),
      mount: () => Promise.resolve(),
      unmount: () => Promise.resolve(),
    } as MicrofrontendApp;
  }
}

const pathPrefix = (prefix: string) => (location: Location) =>
  location.pathname.startsWith(prefix);

registerApplication({
  name: "@ineni-org/Gateway",
  app: async () => loadApp({ name: "@ineni-org/Gateway" }),
  activeWhen: [pathPrefix("/")], // Actif sur la racine
  customProps: { state: { publish, subscribe, unSubscribe } },
});

registerApplication({
  name: "@ineni-org/Admin",
  app: () => loadApp({ name: "@ineni-org/Admin" }),
  activeWhen: [pathPrefix("/app/admin")],
  customProps: { state: { publish, subscribe, unSubscribe } },
});

registerApplication({
  name: "@ineni-org/CashApp",
  app: () => loadApp({ name: "@ineni-org/CashApp" }),
  activeWhen: [pathPrefix("/app/cashapp")],
  customProps: { state: { publish, subscribe, unSubscribe } },
});

registerApplication({
  name: "@ineni-org/StockManagementApp",
  app: () => loadApp({ name: "@ineni-org/StockManagementApp" }),
  activeWhen: [pathPrefix("/app/stockmanagementapp")],
  customProps: { state: { publish, subscribe, unSubscribe } },
});

registerApplication({
  name: "@ineni-org/CommunicationApp",
  app: () => loadApp({ name: "@ineni-org/CommunicationApp" }),
  activeWhen: [pathPrefix("/app/communicationapp")],
  customProps: { state: { publish, subscribe, unSubscribe } },
});

start();

// import { registerApplication, start } from "single-spa";
// import {
//   constructApplications,
//   constructRoutes,
//   constructLayoutEngine,
// } from "single-spa-layout";
// import microfrontendLayout from "./microfrontend-layout.html";
// import PubSub from "pubsub-js";

// const publish = (event: string, data: any) => PubSub.publish(event, data);
// const subscribe = (event: string, callback: any) =>
//   PubSub.subscribe(event, callback);

// subscribe("test", (data: any, d: any) => console.log(data, " => ", d));
// publish("test", { url: "http://localhost:8080/" });

// const gatewayAppUrl = "http://localhost:4000";

// async function loadCssFromManifest() {
//   const manifestUrl = `${gatewayAppUrl}/.vite/manifest.json`;
//   try {
//     const response = await fetch(manifestUrl);
//     const manifest = await response.json();
//     const cssFile = manifest["style.css"];
//     return [gatewayAppUrl + "/" + cssFile.file];
//   } catch (error) {
//     console.error("Error loading CSS from manifest:", error);
//     return [];
//   }
// }

// interface MicrofrontendApp {
//   bootstrap: () => Promise<void>;
//   mount: () => Promise<void>;
//   unmount: () => Promise<void>;
// }

// const routes = constructRoutes(microfrontendLayout, {
//   props: { myProp: "Root Config", state: { publish, subscribe } },
//   loaders: [],
// });

// const applications = constructApplications({
//   routes,
//   async loadApp({ name }: { name: string }) {
//     console.log("================================");
//     console.log(`Loading ${name}`);
//     console.log("================================");

//     const isGatewayApp = name === "@ineni-org/Gateway";
//     if (isGatewayApp) {
//       const result = await loadCssFromManifest();
//       console.log("result: ", result);
//     }

//     try {
//       const appModule = await System.import(name);
//       const { bootstrap, mount, unmount } = appModule;

//       if (
//         Array.isArray(bootstrap) &&
//         Array.isArray(mount) &&
//         Array.isArray(unmount)
//       ) {
//         return appModule as MicrofrontendApp;
//       }

//       if (
//         appModule &&
//         typeof bootstrap === "function" &&
//         typeof mount === "function" &&
//         typeof unmount === "function"
//       ) {
//         return appModule as MicrofrontendApp;
//       }

//       throw new Error(
//         `Module ${name} does not have required lifecycle methods.`
//       );
//     } catch (error) {
//       console.error(`Failed to load application "${name}":`, error);
//       // Retourner un fallback conforme au type attendu
//       return {
//         bootstrap: () => Promise.resolve(),
//         mount: () => Promise.resolve(),
//         unmount: () => Promise.resolve(),
//       } as MicrofrontendApp;
//     }
//   },
// });
// const layoutEngine = constructLayoutEngine({ routes, applications });

// applications.forEach(registerApplication);
// layoutEngine.activate();

// start();
